export const getEventCoords = (event) => {
  const x = event.clientX || event.touches?.[0]?.clientX;
  const y = event.clientY || event.touches?.[0]?.clientY;

  return { x, y };
};
